export const environment = {
  WS_GRAPHQL_ENDPOINT: 'ws://api.np.traintogo.de/graphql',
  HTTP_GRAPHQL_ENDPOINT: 'https://api.np.traintogo.de/graphql',
  AUTH0_GRAPHQL_AUDIENCE: 'https://graphql.np.ppm.wellyou.de',
  AUTH0_DOMAIN: 'ppm-wellyou-np.eu.auth0.com',
  AUTH0_CLIENT_ID: 'dKh1qBbawTk6VilMR9rDY2Gym9QU2cYQ',
  STAGE: 'np',
  HOST: 'manage.np.traintogo.de',
  ASSET_URL:
    'https://ppm-assets-np.s3.eu-central-1.amazonaws.com/traintogo-management-portal/public/assets',
};
